export default __webpack_public_path__ + "static/media/star-solid.cbae9faf.svg";